import React from 'react';
import { Grid, Box, Typography, Card } from '@mui/material';
import { motion } from 'framer-motion';
import tireImage from 'assets/images/td_img.png';

const TreadDepthDirectionCard = ({
  title = 'Add New Tire',
  outsideLabel = 'Outer',
  insideLabel = 'Inner',
  instruction = 'Measure from inner to outer edge of the tire.',
  imageSrc = tireImage,
}) => {
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        boxShadow: 3,
        bgcolor: 'background.paper',
        maxWidth: 360,
        width: '100%',
      }}
    >
      {/* Title */}
      <Typography variant="h6" align="center" gutterBottom>
        {title}
      </Typography>

      {/* Labels + Animated Arrow */}
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        spacing={1}
        mb={2}
        sx={{ flexWrap: 'nowrap' }}
      >
        {/* Inner Label */}
        <Grid item>
          <Box
            px={1.5}
            py={0.5}
            bgcolor="grey.900"
            color="common.white"
            borderRadius={1}
            fontSize={12}
            fontWeight={600}
          >
            {outsideLabel}
          </Box>
        </Grid>

        {/* Animated Arrow Container */}
        <Grid item>
          <Box
            sx={{
              width: 40,
              height: 20,
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            <motion.svg
              initial={{ x: 0 }}
              animate={{ x: 20 }}
              transition={{
                repeat: Infinity,
                repeatType: 'reverse',
                duration: 1.2,
                ease: 'easeInOut',
              }}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
              style={{
                position: 'absolute',
                left: 0,
                top: 0,
                height: '20px',
                width: '20px',
                color: '#1976d2',
              }}
            >
              <path d="M5 12h14M13 5l7 7-7 7" />
            </motion.svg>
          </Box>
        </Grid>

        {/* Outer Label */}
        <Grid item>
          <Box
            px={1.5}
            py={0.5}
            bgcolor="grey.900"
            color="common.white"
            borderRadius={1}
            fontSize={12}
            fontWeight={600}
          >
            {insideLabel}
          </Box>
        </Grid>
      </Grid>

      {/* Tire Image */}
      <Box
        sx={{
          width: '100%',
          height: 100,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: '1px solid #ccc',
          borderRadius: 1,
          backgroundColor: '#f5f5f5',
          overflow: 'hidden',
        }}
      >
        <Box
          component="img"
          src={imageSrc}
          alt="Tire Cross Section"
          onError={(e) => {
            e.currentTarget.src = tireImage;
          }}
          sx={{
            maxHeight: '80px',
            maxWidth: '100%',
            objectFit: 'contain',
          }}
        />
      </Box>

      {/* Instruction */}
      <Card
  elevation={1}
  sx={{
    mt: 2,
    width: '100%',
    px: 2,
    py: 1,
    bgcolor: 'grey.100',
    borderRadius: 2,
  }}
>
  <Typography
    variant="caption"
    sx={{
      textAlign: 'center',
      color: 'text.secondary',
    }}
  >
    {instruction}
  </Typography>
</Card>

    </Box>
  );
};

export default TreadDepthDirectionCard;
